export default function PricingIcon() {
    return (
    <svg viewBox="0 0 24 24" xmlns="https://www.w3.org/2000/svg">
		<g data-name="Layer 2">
			<g data-name="Layer 1">
				<path data-name="Rectangle 1156" fill="none" d="M0 0h24v24H0z"/>
				<path d="M12.5 12.62V15c1-.11 1.35-.7 1.35-1.2 0-.67-.59-.95-1.35-1.18z" fill="#333"/>
				<path d="M21.42 8.89l-2.74-1.8-.86-3.16-3.28.16L12 2 9.42 4.09l-3.28-.16-.85 3.17-2.75 1.79L3.71 12l-1.17 3 2.75 1.8.85 3.2 3.28-.17L12 21.89l2.56-2.06 3.28.17.85-3.17L21.42 15l-1.16-3zm-8.92 7.2v1.08h-.85V16.1a4 4 0 0 1-2.76-1.26l.69-.92A3.36 3.36 0 0 0 11.65 15v-2.61c-1.22-.31-2.51-.75-2.51-2.26a2.41 2.41 0 0 1 2.51-2.27v-1.1h.85v1.11A3.76 3.76 0 0 1 14.89 9l-.71.89A2.89 2.89 0 0 0 12.5 9v2.33c1.25.34 2.57.8 2.57 2.39 0 1.13-.74 2.22-2.57 2.37z" fill="#333"/>
				<path d="M10.38 10c0 .58.55.84 1.27 1.05V8.93c-.77.07-1.27.49-1.27 1.07z" fill="#333"/>
			</g>
		</g>
	</svg>
    );
  }
  